module.exports = __webpack_public_path__ + "static/rwCube-6fd7e8125efbc5941d0fa17a434541bd.jpg";